var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"menu-button menu",class:{'enabled': _vm.enabled}},[_c('button',{staticClass:"btn",on:{"click":_vm.switchMenu}},[_vm._t("button")],2),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.enabled),expression:"enabled"}],staticClass:"menu-elements"},[_vm._t("elements")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }